export default {"src":"/polygon/_next/static/media/partner_4.50ed0113.svg","height":121,"width":180};